// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"98483a38c34a6daa82d9","691":"e6d3820387573ec636f2"}[chunkId] + ".js";
};